// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const footer = "CommonFooter__footer__Uvvqx";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const link = "CommonFooter__link__C5E2- font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const linkWrapper = "CommonFooter__linkWrapper__chSdi";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const securityIconWrapper = "CommonFooter__securityIconWrapper__rYw8O";
export const semibold = "600";
export const serif = "'serif'";